import { useMutation } from '@tanstack/react-query';

import { sky } from '@/services/api-client';
import { deleteAppContextCookie } from '@/services/context/queries';
import { ServiceError } from '@/services/utils/service-error';

/**
 * React-query mutation for logout.
 *
 * Next.js server actions are bad in the sense that you can't access the response,
 * so we can't set headers or cookies (JWT session), which the client would then access.
 * So, make the call from client -> server, instead of server -> server.
 */
export const useLogout = () => {
  return useMutation<void, ServiceError>({
    mutationFn: () => sky.post<void>('/auth/logout'),
    // The org-context cookie is host-only on the web app's origin, so the
    // API server can't expire it — purge it here, even if the request fails.
    onSettled: () => {
      deleteAppContextCookie();
    },
  });
};
